import Hot from "../api/model/hot/index.js"
import Nav from "../api/model/nav/index.js"
import Story from "../api/model/story/index.js"
import User from "../api/model/user/index.js"
import Util from "../utils/util.js"
import objUtil from "../utils/objUtil.js"
import Storage from "../utils/storage.js"
import CONFIG from "@/js/utils/config";
import search from "./searchV5.js"
let {searchStoryBut,searchKeywords} = search
window.searchStoryBut = searchStoryBut
window.searchKeywords = searchKeywords

const initLogin = async function (){
    var access_token = $.cookie('access_token');
    //access_token不存在 展示登录按钮
    if(access_token=="" || access_token == null){
        $(".login-user").hide();
        $('.login-box>.head-top-top-inner-right-left-icon').show();
        Storage.removeStorage({key:"user"})
    }else{
        $('.login-box>.head-top-top-inner-right-left-icon').hide();
        var res = await User.getUserProfile()
        if(Util.isNull(res))return
        let user = res.data
        Storage.setStorage({key:"user",value:user})
        var username = res.data.username;
        //展示用户名
        //$("#showUserName").text("["+username+"]");
        var uuid = res.data.uuid;
        Storage.setCookie({key:"uuid",value:uuid,domain: '.tkww.hk'})
        var res = await User.getUserAvatar({uuid})
        if(Util.isNull(res)){
            $(".login-user").hide();
            $('.login-box>.head-top-top-inner-right-left-icon').show();
            return
        }
        user = {...user,...res}
        Storage.setStorage({key:"user",value:user})
        $('.login-user .head-top-top-inner-right-left-icon').attr('src',res.url);
        $(".login-user").show();
        $('.login-box>.head-top-top-inner-right-left-icon').hide();
    }
}
const initDownload=function (){
    let $downloadImg = $(".download-img")
    let objUtil2 = Util.deepCopyObjectWithMethods(objUtil)
    let setFunc = (params) => objUtil2.timerUtil.setFunc(params)//防抖方法
    //let isShow = 0
    function downloadMouseenter(){
        $(".download-orcode-box").fadeIn(500)
        let src = $downloadImg.attr("src")
        let index = src.lastIndexOf("/")
        src = `${src.slice(0,index)}/download-red.png`
        $downloadImg.attr("src",src)
        //isShow=1
    }
    function downloadMouseleave(){
        $(".download-orcode-box").fadeOut(500)
        let src = $downloadImg.attr("src")
        let index = src.lastIndexOf("/")
        src = `${src.slice(0,index)}/download.png`
        $downloadImg.attr("src",src)
        //isShow=0
    }
    $(".download").mouseenter(function(){
        setFunc({func:downloadMouseenter,time:800,isRun:1})
    }).mouseleave(function(){
        setFunc({func:downloadMouseleave,time:800})
    })
    /*if(window.innerWidth>767){
    }else{
      $(".download").click(function(){
        if(!isShow){
          setFunc({func:downloadMouseenter,time:800,isRun:1})
        }else{
          setFunc({func:downloadMouseleave,time:800})
        }
      })
    }*/
}
const initHotWord = async function (){
    let res = await Hot.common()
    if(Util.isNull(res))return
    let data = res.data.content
    for(let i = 0;i<data.length;i++){
        if(data[i].showChannelFlag===2||data[i].showChannelFlag===0){
            $(".nav-column-hot-title").html(data[i].name)
            $(".nav-column-hot").css("display","flex").click(function(){
                searchKeywords($(".nav-column-hot-title").eq(0),0)
            })
            break;
        }
    }
}
let navCurrent = "nav-current"
function headBottomNavInit(){
    var {column,site} = globalData
    if(column!=null){
        var {parentColumns,uuid} = column
        if(parentColumns.length!==0 && uuid!=='5fa39b28e4b024217fcc7a3a'){
            uuid = parentColumns[parentColumns.length-1].uuid
            if(uuid==='5ee72afae4b0cc64d0f5d568')uuid='60cc8eade4b0c7e5bec70ad0'
        }
        if(uuid==='5ee72ae8e4b0cc64d0f5d567'){//首頁
            $(`.nav-column[siteid=${site.uuid}]`).addClass(navCurrent)
        }else{
            $(`.nav-column[columnid=${uuid}]`).addClass(navCurrent)
        }
        $(function(){
            let $navCurrent = $(`.head-bottom-inner .${navCurrent}`)
            let $headBottomScroll = $(".head-bottom-inner")
            for(let i = 0;i<$navCurrent.length;i++){
                if(Util.isNull($headBottomScroll[i])||$headBottomScroll[i].offsetWidth===0)continue;
                let offsetLeft = $navCurrent[i].offsetLeft - $headBottomScroll[i].offsetLeft
                let leftWidth = offsetLeft+$navCurrent[i].offsetWidth
                if($headBottomScroll[i].offsetWidth>leftWidth)continue;
                let isScroll = $headBottomScroll.eq(i).attr("is-scroll")
                if(Util.isNull(isScroll)){
                    $headBottomScroll.eq(i).attr("is-scroll","true")
                    $headBottomScroll[i].scrollTo({
                        left:offsetLeft
                    })
                }
            }
        })
        return
    }
    $(`.nav-column[siteid=${site.uuid}]`).addClass("nav-current")
}
//导航栏栏目鼠标悬停
const headBottomHoverInit = function (){
    let objUtil2 = Util.deepCopyObjectWithMethods(objUtil)
    let setFunc = (params) => objUtil2.timerUtil.setFunc(params)//防抖方法
    //导航栏栏目鼠标悬停添加悬停类
    function addClass(e){
        let columnid = $(e).attr("columnid")
        var columnBox = $(e).parents(".head-bottom,.head-top-bottom").eq(0).find(`.column-hover-box[columnid = ${columnid}]`)
        headBottomNavColumnInit(columnid,columnBox)
        let activeClass="column-hover-box-active"
        columnBox.addClass(activeClass)


        //導航欄廣告展示埋點
        /*let $daList = columnBox.find(".da-box-list-1-unit,.da-box-list-3-unit,.da-box-list-4-unit")
        for(let i = 0;i<$daList.length;i++){
          let width = $daList[i].getBoundingClientRect().width
          let height = $daList[i].getBoundingClientRect().height
          if(width||height)continue;
          let adReport1Str = $daList.eq(i).attr("onclick")
          if(typeof adReport1Str==="undefined" || adReport1Str.indexOf("adReport1")===-1)continue;
          const regex = /adReport1\((.*?)\)/;
          const match = adReport1Str.match(regex);
          if (match) {
            const params = match[1].split(',').map(param => param.replace(/'/g, ''));
            let adSpaceId = params[0]
            let linkStoryUrl = params[1]
            let adUrl = params[2]
            let title = params[3]
            adReport1(adSpaceId,linkStoryUrl,adUrl,title,"eventShow")
          }
        }*/
    }
    //导航栏栏目鼠标离开删除悬停类
    function removeClass(e){
        let columnid = $(e).attr("columnid")
        var columnBox = $(`.column-hover-box[columnid = ${columnid}]`)
        columnBox.removeClass("column-hover-box-active")
    }
    if(!Util.isPcV5())return
    $(".nav-column").mouseenter(function(){
        setFunc({func:addClass,params:this,time:800,isRun:1})
    }).mouseleave(function(){
        setFunc({time:800})
        removeClass(this)
    })
    $(".column-hover-box").mouseenter(function(){
        let columnid = $(this).attr("columnid")
        var navColumn = $(`.nav-column[columnid = ${columnid}]`)
        navColumn.addClass("hover-current")
    }).mouseleave(function(){
        let columnid = $(this).attr("columnid")
        var navColumn = $(`.nav-column[columnid = ${columnid}]`)
        navColumn.removeClass("hover-current")
    })
}
let columnBoxObj = {}
const headBottomNavColumnInit = function (columnid,$columnBox){
    if(!$columnBox.length)return
    let isLoad = $columnBox.attr("is-load")
    if(isLoad==='true')return
    $columnBox.attr("is-load","true")
    function getSlideHtml(resData,columnUuid){
        let staticUrl = CONFIG.BASE_STATIC_URL;// 用来显示默认图片的
        let html = ""
        if(resData.length===0)return "暫無數據"
        if(columnUuid==='5ee72b09e4b0cc64d0f5d569'){//視頻
            for(let i=0;i<8&&i<resData.length;i++){
                html += '<div class="common-column-list-unit-1">'
                html += '  <div class="common-column-list-unit-img-1">'
                html += '    <div class="img-box-box">'
                html += '      <a class="img-box" rel="noopener norefferrer" title="'+ resData[i].title +'" href="'+ resData[i].url +'">'
                html += '        <img class="img-box-filter" src="'+ (resData[i].thumbnails&&resData[i].thumbnails.length?resData[i].thumbnails[0].url+'?x-oss-process=image/resize,w_300':staticUrl + 'index-HKTKWW/story-img-default.png') +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
                html += '        <img class="img-box-img" src="'+ (resData[i].thumbnails&&resData[i].thumbnails.length?resData[i].thumbnails[0].url+'?x-oss-process=image/resize,w_300':staticUrl + 'index-HKTKWW/story-img-default.png') +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
                html += '      </a>'
                html += '      <a class="img-box-video-message" rel="noopener norefferrer" href="'+resData[i].url+'" title="'+resData[i].title+'">'
                html += '        <img class="img-box-video-play" src="https://tkww-static.tkww.hk/v5/index/index/play.png" title="'+resData[i].title+'" alt="'+resData[i].title+'">'
                html += '      </a>'
                html += '    </div>'
                html += '  </div>'
                if(i<2){
                    html += '  <div class="common-column-list-unit-content-1">'
                    html += '    <a class="common-column-list-unit-title-1 '+(i<2?"threeLine":"twoLine")+'" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].title +'">'+ resData[i].title +'</a>'

                    html += '    <div class="common-column-list-unit-bottom-1">'
                    let tagStr = resData[i].tags?resData[i].tags.join(","):""
                    if(tagStr!==""){
                        html += '      <div class="common-column-list-unit-bottom-tag-1" onclick="tagsClick(this)">'+tagStr+'</div>'
                    }
                    html += '      <span class="common-column-list-unit-bottom-time-1"><span class="common-column-list-unit-bottom-time-left-1">'+Util.getEndTime({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})+'</span></span>'
                    html += '    </div>'
                    html += '  </div>'
                }
                html += '</div>'
            }
        }else{
            for(let i=0;i<6&&i<resData.length;i++){
                html += '<div class="common-column-list-unit-1">'
                if(i<2){
                    html += '  <div class="common-column-list-unit-img-1">'
                    html += '    <div class="img-box-box">'
                    html += '      <a class="img-box" rel="noopener norefferrer" title="'+ resData[i].title +'" href="'+ resData[i].url +'">'
                    html += '        <img class="img-box-filter" src="'+ (resData[i].thumbnails&&resData[i].thumbnails.length?resData[i].thumbnails[0].url+'?x-oss-process=image/resize,w_300':staticUrl + 'index-HKTKWW/story-img-default.png') +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
                    html += '        <img class="img-box-img" src="'+ (resData[i].thumbnails&&resData[i].thumbnails.length?resData[i].thumbnails[0].url+'?x-oss-process=image/resize,w_300':staticUrl + 'index-HKTKWW/story-img-default.png') +'" title="'+ resData[i].title +'" alt="'+ resData[i].title +'">'
                    html += '      </a>'
                    html += '    </div>'
                    html += '  </div>'
                }
                html += '  <div class="common-column-list-unit-content-1">'
                html += '    <a class="common-column-list-unit-title-1 '+(i<2?"threeLine":"twoLine")+'" rel="noopener norefferrer" href="'+ resData[i].url +'" title="'+ resData[i].title +'">'+ resData[i].title +'</a>'
                if(i<2){
                    html += '    <div class="common-column-list-unit-bottom-1">'
                    let tagStr = resData[i].tags?resData[i].tags.join(","):""
                    if(tagStr!==""){
                        html += '      <div class="common-column-list-unit-bottom-tag-1" onclick="tagsClick(this)">'+tagStr+'</div>'
                    }
                    html += '      <span class="common-column-list-unit-bottom-time-1"><span class="common-column-list-unit-bottom-time-left-1">'+Util.getEndTime({fmt:'YYYY.mm.dd HH:MM',publishTime:resData[i].publishTime})+'</span></span>'
                    html += '    </div>'
                }
                html += '  </div>'
                html += '</div>'
            }
        }
        return html
    }
    async function initRightSwiper($columnBox,$columnBoxRightSwiperSlideInner,columnUuid,$columnBoxRightSwiperSlideInnerEqj){
        /*let res1 = await Story.getStoryList({column:columnUuid})
        if(Util.isNull(res1))return
        let resData1= res1.data.stories
        let html1 = getSlideHtml(resData1)
        $columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu-swiper-slide-inner").eq(1).html(html1)*/
        if($columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu-swiper").length===0)return
        let swiper =new Swiper($columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu-swiper"), {
            effect: 'slide',
            allowTouchMove: false,
            preventClicks: false,
            on:{
                init:function(){
                    let swiper = this
                    let addClass="column-box-right-menu-unit-active"
                    $columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu .column-box-right-menu-unit").mouseenter(function(){
                        swiper.slideTo($(this).index())
                        $columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu .column-box-right-menu-unit").removeClass(addClass)
                        $(this).addClass(addClass)
                    })
                }
            }
        })
    }
    async function initColumnBox($columnBox,$columnBoxRightSwiperSlideInner,columnid){
        let swiper1 =new Swiper($columnBox.find(".column-box-right-swiper"), {
            effect: 'fade',
            allowTouchMove: false,
            preventClicks: false,
            //direction: 'vertical',
            on:{
                init:function(){
                    let swiper = this
                    let addClass="column-box-left-unit-active"
                    $columnBox.find(".column-box-left-unit").mouseenter(function(){
                        swiper.slideTo($(this).index())
                        $columnBox.find(".column-box-left-unit").removeClass(addClass)
                        $(this).addClass(addClass)
                    })
                }
            }
        })
        for(let j=0;j<$columnBoxRightSwiperSlideInner.length;j++){
            let $columnBoxRightSwiperSlideInnerEqj = $columnBoxRightSwiperSlideInner.eq(j)
            let columnUuid = $columnBoxRightSwiperSlideInnerEqj.attr("columnid")
            if(Util.isNull(columnUuid))continue;
            let res
            if(columnBoxObj[columnUuid]){
                res = columnBoxObj[columnUuid]
            }else{
                res = await Story.getHotList({channelId:"tkww",hours:24,columnUuid,includeInnerlink:true})//,baseUrl:CONFIG.BASE_URL
                columnBoxObj[columnUuid] = res
            }
            if(Util.isNull(res))return
            let resData= res.data
            let html = getSlideHtml(resData,columnid)
            $columnBoxRightSwiperSlideInnerEqj.find(".column-box-right-menu-swiper-slide-inner").eq(1).html(html)
            initRightSwiper($columnBox,$columnBoxRightSwiperSlideInner,columnUuid,$columnBoxRightSwiperSlideInnerEqj)
        }
    }
    let $columnBoxRightSwiperSlideInner = $columnBox.find($(".column-box-right-swiper-slide-inner"))
    initColumnBox($columnBox,$columnBoxRightSwiperSlideInner,columnid)
    /*for(let i = 0;i<$columnBox.length;i++){
      //let columnUuid = $columnBox.eq(i).attr("columnid")
      let $columnBoxEqI = $columnBox.eq(i)
      let $columnBoxRightSwiperSlideInner = $columnBoxEqI.find($(".column-box-right-swiper-slide-inner"))
      initColumnBox($columnBoxEqI,$columnBoxRightSwiperSlideInner)
    }*/
}
const getNavData = async function (){
    let res = await Nav.getDataV5()
    if(Util.isNull(res))return
    var objE = document.createElement("div")
    objE.innerHTML = res
    let $html = $(objE.innerHTML)
    $(".head-bottom,.head-top-bottom").append($html)
}
const initNav = async function (){
    let {isAndroid_app,isiOS_app} = globalData
    let isApp = isAndroid_app || isiOS_app
    if(isApp){
        $(".page-head").remove()
        return
    }
    if(!Util.isPcV5()){
        return
    }
    await getNavData()
    headBottomHoverInit()
}
const initHeadLeft= function (){
    /*let $list=$(".head-left-inner-right-bottom-list-unit-children")
    for(let i = 0;i<$list.length;i++){
      let $listI = $list.eq(i)
      let height = $listI[0].getBoundingClientRect().height
      $listI.attr("active-height",height)
    }*/
    $(".head-left-inner-right-bottom-list-unit-parent").click(function(){
        let $parent = $(this).parents(".head-left-inner-right-bottom-list-unit-has-children").eq(0)
        let $children = $parent.find(".head-left-inner-right-bottom-list-unit-children")
        let activeHeight = $children.attr("active-height")
        let addClass = "head-left-inner-right-bottom-list-unit-has-children-active"
        if(!activeHeight){
            activeHeight = $children[0].getBoundingClientRect().height
            $children.attr("active-height",activeHeight)
        }
        let height = $children.height()
        if(height === 0){
            $children.height(activeHeight)
            $parent.addClass(addClass)
            return
        }
        $parent.removeClass(addClass)
        $children.height(activeHeight)
        $children.height(0)
    })
    let $menu = $(".nav-column-menu")
    $(".head-left-inner-right-top-close").click(function(){
        $(".head-left").fadeOut(500)
        $menu.removeClass(navCurrent)
        $(".page-head").css("z-index","")
    })
    $menu.mouseenter(function(){
        $(".head-left").fadeIn(500)
        $menu.addClass(navCurrent)
        $(".page-head").css("z-index","399")
    })
}
const pageHeadScroll = function (){
    let $scrollPage= $(".scroll-page")
    function onScroll(){
        let height = ($(".page-head")[0]?.getBoundingClientRect().height||0)
        let scrollTop = $scrollPage[0]?.scrollTop||0
        headBottomNavInit()
        if(scrollTop>height){
            $(".head-top-bottom .column-box").hide()
            $(".head-bottom").show()
            return
        }
        $(".head-top-bottom .column-box").show()
        $(".head-bottom").hide()
    }
    $scrollPage.on("scroll",onScroll)
    onScroll()
}
const initSearch = function (){
    $('#head-top-top-inner-search-input-id').bind('keydown','#head-top-top-inner-search-input-id', function (event) {
        var event = window.event || arguments.callee.caller.arguments[0];
        //console.log(".search-top-left",event.keyCode,$(this).attr("id"))
        var inputId = $(this).attr("id")
        if (event.keyCode == 13 && inputId == "head-top-top-inner-search-input-id"){
            searchStoryBut({inputStr:"#head-top-top-inner-search-input-id"});
            // $(".header-search .searchbutton").click();
            return;
        }
    });
}
export default {
    initLogin,
    initHotWord,
    initNav,
    initHeadLeft,
    pageHeadScroll,
    initSearch
}